import { createAsyncThunk } from "@reduxjs/toolkit";
import { EndPoints } from "../../api/endpoints";
import axiosClient from "../../api/axiosClient";

export type Atc = {
  name: string;
  icon: string;
  id: string;
};
export const getAtc = createAsyncThunk(
  "getAtc",
  async (_, { rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.get(EndPoints.atc);
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const addAtc = createAsyncThunk(
  "addAtc",
  async (data: Atc, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.put(EndPoints.atc, data);
      dispatch(getAtc());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);

export const deleteAtc = createAsyncThunk(
  "deleteAtc",
  async (id: string, { dispatch, rejectWithValue }): Promise<any> => {
    try {
      const response = await axiosClient.delete(`${EndPoints.atc}/${id}`);
      dispatch(getAtc());
      return response.data;
    } catch (error: any) {
      return rejectWithValue({
        message: error.message,
        description: error?.response?.data?.status,
      });
    }
  }
);
